export default __webpack_public_path__ + "static/media/Cover.45ee7537.jpg";